var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "body_head" },
        [
          _c(
            "div",
            { staticClass: "head_left", on: { click: _vm.resourceInfo } },
            [
              _c("div", { staticClass: "showCard-imgBox" }, [
                _c("div", { staticStyle: { position: "relative" } }, [
                  _c("img", {
                    attrs: { src: _vm.productObj.imageUrl, alt: "" },
                  }),
                  _vm.showTag
                    ? _c("b", { staticClass: "tag" }, [_vm._v("专属")])
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "head_center" }, [
                _c("div", { staticClass: "resourceNameCn" }, [
                  _c(
                    "span",
                    {
                      staticClass: "name",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goToResourceDetail(_vm.productObj)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.productObj.nameCn))]
                  ),
                  _vm.productObj.nameCn != _vm.productObj.nameEn
                    ? _c("span", [_vm._v(_vm._s(_vm.productObj.nameEn))])
                    : _vm._e(),
                  _vm.productObj.state == 6
                    ? _c("span", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(
                            "内含" +
                              _vm.productObj.stockListResults.length +
                              "个签证产品"
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm.productObj.star
                    ? _c(
                        "span",
                        _vm._l(_vm.productObj.star, function (item) {
                          return _c("i", {
                            key: item,
                            staticClass: "el-icon-star-on",
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.productObj.state == 2
                    ? _c("div", [
                        _vm.productObj.otherResourceData.mainSpot == 1
                          ? _c("span", { staticClass: "spanCard" }, [
                              _vm._v("主景点"),
                            ])
                          : _vm._e(),
                        _vm.productObj.otherResourceData.mustGo == 1
                          ? _c("span", { staticClass: "spanCard" }, [
                              _vm._v("人气"),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm.productObj.productType == 1
                  ? _c(
                      "div",
                      { staticClass: "icon" },
                      [
                        _c("svg-icon", { attrs: { iconClass: "fire" } }),
                        _c("span", [
                          _vm._v(
                            "使用次数：" +
                              _vm._s(_vm.productObj.useCount) +
                              "次"
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.productObj.labels && _vm.productObj.labels.length > 0
                  ? _c(
                      "div",
                      { staticClass: "labelContain" },
                      _vm._l(_vm.productObj.labels, function (item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "label" },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.productObj.addressCn != "" || _vm.productObj.address != ""
                  ? _c("div", { staticClass: "addressBox" }, [
                      _c("i", { staticClass: "el-icon-location" }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.productObj.addressCn != ""
                              ? _vm.productObj.addressCn
                              : _vm.productObj.address
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.productObj.state == 2
                  ? _c("div", { staticClass: "spotBox" }, [
                      _c("span", [
                        _vm._v(
                          "热度：" +
                            _vm._s(_vm.productObj.otherResourceData.usageRate) +
                            "%"
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          "游玩：约" +
                            _vm._s(_vm.productObj.otherResourceData.playTime)
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          "排名：1" +
                            _vm._s(_vm.productObj.otherResourceData.ranking)
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.productObj.introduction && _vm.productObj.introduction != ""
                  ? _c(
                      "div",
                      { staticClass: "addressBox" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "top",
                              "popper-class": "addressBoxTip",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(_vm.productObj.introduction))]
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.productObj.introduction)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _vm.rightAction
            ? _c("div", { staticClass: "head_right" }, [
                _vm.rightShowStyle == 2
                  ? _c("div", { staticClass: "head_right1" }, [
                      _c("div", { staticClass: "cardContainer" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cardContainer-oneBox",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDirectPopup(_vm.productObj)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.btnName))]
                            ),
                            _c("div", { staticClass: "cardContainer-twoBox" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "circle",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addReferResource(
                                        _vm.productObj
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-star-off" })]
                              ),
                              _c("span", { staticClass: "fractionBox" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.productObj.score) + "分"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.productObj.productType == 3
                                        ? "/5分"
                                        : "/10分"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "showCard-tag" }, [
                        _c("div", [
                          _c("i", {
                            class: _vm.productObj.isOpen
                              ? "el-icon-caret-top"
                              : "el-icon-caret-bottom",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openPriceDetail(_vm.productObj)
                              },
                            },
                          }),
                        ]),
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.productObj.price))]),
                          _c("b", { staticStyle: { "font-size": "0.12rem" } }, [
                            _vm._v(_vm._s(_vm.productObj.currency)),
                          ]),
                          _c("label", [_vm._v("起")]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.rightShowStyle == 1
                  ? _c("div", { staticClass: "head_right1" }, [
                      _c("div", { staticClass: "cardContainer" }, [
                        _c("div", { staticClass: "cardContainer-oneBox" }, [
                          _c("div", { staticClass: "circle" }, [
                            _c("i", {
                              staticClass: "el-icon-star-off",
                              on: {
                                click: function ($event) {
                                  return _vm.addReferBudget(_vm.productObj)
                                },
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.exclusiveAddYsP(_vm.productObj)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.btnName))]
                            ),
                          ]),
                          _c("div", { staticClass: "cardContainer-twoBox" }, [
                            _vm.btnName1 != ""
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "cirleXun",
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inquiryResource(
                                          _vm.productObj
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.btnName1))]
                                )
                              : _vm._e(),
                            _c("span", { staticClass: "fractionBox" }, [
                              _c("b", [
                                _vm._v(_vm._s(_vm.productObj.score) + "分"),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.productObj.productType == 6
                                      ? "/10分"
                                      : "/5分"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "showCard-tag",
                          on: {
                            click: function ($event) {
                              return _vm.openPriceDetail()
                            },
                          },
                        },
                        [
                          _c("div", [
                            _vm.productObj.price != ""
                              ? _c("i", {
                                  class: _vm.productObj.isOpen
                                    ? "el-icon-caret-top"
                                    : "el-icon-caret-bottom",
                                })
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.productObj.price == ""
                                    ? _vm.priceNullStr
                                    : _vm.productObj.price
                                )
                              ),
                            ]),
                            _c(
                              "b",
                              { staticStyle: { "font-size": "0.12rem" } },
                              [_vm._v(_vm._s(_vm.productObj.currency))]
                            ),
                            (_vm.productObj.productType == 1 ||
                              _vm.productObj.productType == 3) &&
                            _vm.productObj.price != ""
                              ? _c("label", [_vm._v("起")])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._t("headRight"),
        ],
        2
      ),
      _c("add-refer-resource", {
        ref: "addReferResource",
        attrs: { resourceObj: _vm.productObj },
      }),
      _c("resource-detail", { ref: "resourceDetail" }),
      _c("directPopup", { ref: "directPopup" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }